import { Box, SxProps, useTheme } from '@mui/material'
import React from 'react'
import { darkScrollbarStyles, lightScrollbarStyles } from 'theme/tokens'
const FlexRow = ({ children, extraStyles }: { children: React.ReactNode; extraStyles?: SxProps }) => {
  const theme = useTheme()
  const scrollbarProps = theme.palette.mode === 'light' ? lightScrollbarStyles : darkScrollbarStyles
  return (
    <Box
      sx={{
        ...scrollbarProps,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflowY: 'auto',
        ...(extraStyles ? extraStyles : {}),
      }}
    >
      {children}
    </Box>
  )
}

export default FlexRow
